export const departmentQueryKeys = {
  all: ["company-positions"],
};
